//modernized save ui routes
export enum SaveModRoutes {
  CREATE_CASE = '/save/app/client/',
  SEARCH_CASES = '/save/app/client/search',
  FIND_CASE = '/save/app/client/find',
  MESSAGE_CENTER = '/save/app/client/ui/home/messageCenter',
  HOME = '/save/app/client/ui/home',
  HOME_LOGIN_DOT_GOV_REDIRECT = '/save/app/client/ui/home/loginDotGov',
  RESOURCES = '/save/app/client/ui/help/resources',
  GLOSSARY = '/save/app/client/ui/help/glossary',
  CONTACT_US = '/save/app/client/ui/help/contact-us',
  DEPARTMENT_LIST = '/save/app/client/ui/agencies/departments',
  VIEW_DEPARTMENT = '/save/app/client/ui/agencies/departments',
  GROUP_LIST = '/save/app/client/ui/agencies/groups',
  VIEW_PROFILE = '/save/app/client/ui/profile',
  CHANGE_PASSWORD = '/save/app/client/ui/profile/change-password',
  EDIT_PROFILE = '/save/app/client/ui/profile/edit',
  SITE_MAP = '/save/app/client/ui/help/site-map',
  EV_STAR = '/ev-star/',
  NOT_FOUND = '/save/app/client/ui/404',
  SUPPORTED_BROWSERS = '/save/app/client/ui/supported-browsers',
  REPORTS = '/save/app/client/ui/reports',
  CASE_CHECK = '/save/app/client/ui/case-check',
  USER_SEARCH = '/save/app/client/ui/users',
}

//legacy system routes
export enum SaveLegacyRoutes {
  THIRD_STEP_USER_SEARCH = 'CaseSearchThirdStepOnly.aspx',
  HOME = 'cpshome.aspx',
  SCAN_SERVICE_WIDE = 'ScanServiceWide.aspx',
  REPORTS = 'ReportSelector.aspx?category=agency',
  RESOURCES = 'OnlineResources.aspx',
  GLOSSARY = 'glossary.htm',
  CONTACT_US = 'ContactUs.aspx',
  DEPARTMENT_LIST = 'DepartmentSummaryList.aspx',
  VIEW_DEPARTMENT = 'SiteAdministration.aspx',
  GROUP_LIST = 'GroupSearch.aspx',
  CHANGE_PASSWORD = 'ChangePassword.aspx',
  EDIT_PROFILE = 'ChangeProfile.aspx',
  USER_SEARCH = 'UserSearch.aspx',
}
